import { createRoot } from 'react-dom/client';
import './index.css';
import { RecoilRoot } from 'recoil';
import React, { useEffect } from 'react';

import i18n from './i18n';
import { BrowserRouter, Route, Routes, HashRouter } from 'react-router-dom';
import isElectron from './Global';
import { connectors } from './components/Util/wagmi';
import { WagmiConfig, createClient } from 'wagmi';
import { Buffer } from 'buffer';

import Meeting from './Meeting';
import ElectronTop from './components/ElectronTop/ElectronTop';
import ElectronOneTime from './components/ElectronOneTime/ElectronOneTime';
import ElectronFace from './components/ElectronTop/ElectronFace';
import Test from './components/MobileStudio/Test';
import TestMobile from './components/MobileStudio/TestMobile';
import Setting from './components/Setting/Setting';
import StorageUpload from './components/Util/StorageUpload';
import HPFAQ from './components/HP/HPFAQ';
import BrowserTop from './components/BrowserTop/BrowserTop';
import Feedback from './components/Call/Feedback';
import Recorded from './components/Recorded/Recorded';
import DB from './components/MobileStudio/DB';
import Upload from './components/MobileStudio/Upload';
import { isMobile } from 'react-device-detect';

import MobileTest from './components/MobileTop/MobileTest';
import ElectronRecorded from './components/ElectronTop/ElectronRecorded';

//import React, { Suspense, lazy } from 'react';
// const ElectronTop = lazy(() => import('./components/ElectronTop/ElectronTop'));
// const ElectronOneTime = lazy(() => import('./components/ElectronOneTime/ElectronOneTime'));
// const ElectronFace = lazy(() => import('./components/ElectronTop/ElectronFace'));
// const Setting = lazy(() => import('./components/Setting/Setting'));
// const StorageUpload = lazy(() => import('./components/Util/StorageUpload'));
// const HPTop = lazy(() => import('./components/HP/HPTop'));
// const HPFAQ = lazy(() => import('./components/HP/HPFAQ'));
// const Feedback = lazy(() => import('./components/Call/Feedback'));
// const Recorded = lazy(() => import('./components/Recorded/Recorded'));
// const Meeting = lazy(() => import('./Meeting'));
// const BrowserTop = lazy(() => import('./components/BrowserTop/BrowserTop'));

//import MobileApp from './components/MobileTop/MobileApp';

//wagmiエラー対策用
window.Buffer = Buffer;

const container = document.getElementById('root');
const root = createRoot(container);

document.addEventListener('DOMContentLoaded', function (event) {
  setTimeout(() => {
    //const loader = document.getElementById('initialLoadingBox');
    const elements = document.getElementsByClassName('initialLoadingBox');

    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add('active');
      setTimeout(() => {
        elements[i].remove();
      }, 100);
    }
  }, 300);
});

const client = createClient({
  autoConnect: true,
  connectors,
});

root.render(
  <WagmiConfig client={client}>
    <RecoilRoot>
      <>
        {isMobile && isElectron == false && (
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<MobileTest />} />
              <Route path="/app" element={<MobileTest />} />
              <Route path="/test" element={<TestMobile />} />
              <Route path="/:id" element={<Meeting />} />
              <Route path="/l/:id" element={<Meeting live={true} />} />
              <Route path="/l/:id/:token" element={<Meeting live={true} />} />
              <Route path="/r/:id" element={<Recorded />} />
              <Route path="/metamask" element={<ElectronOneTime />} />
              <Route path="/face" element={<ElectronFace />} />
              <Route path="/faq" element={<HPFAQ />} />
              <Route path="/feedback" element={<Feedback />} />
            </Routes>
          </BrowserRouter>
        )}
        {/* Electronの場合はHashRouterじゃないと動かない */}
        {isElectron && (
          <HashRouter>
            {/* <Suspense
              fallback={
                <div className="initialLoadingBox">
                  <img src="https://d2wp3sepl8g4xv.cloudfront.net/hp/images/logoWhite.png" />
                </div>
              }> */}
            <Routes>
              <Route path="/" element={<ElectronTop />} />
              {/* <Route path="/" element={<BrowserTop />} /> */}
              <Route path="/:id" element={<Meeting />} />
              <Route path="/l/:id" element={<Meeting live={true} />} />
              <Route path="/l/:id/:token" element={<Meeting live={true} />} />
              <Route path="/r/:id" element={<Recorded />} />
              <Route path="/metamask" element={<ElectronOneTime />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="/face" element={<ElectronFace />} />
              <Route path="/feedback" element={<Feedback />} />
            </Routes>
          </HashRouter>
        )}
        {isElectron == false && isMobile == false && (
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<BrowserTop />} />
              <Route path="/verify/:token" element={<BrowserTop verify={true} />} />
              <Route path="/app" element={<BrowserTop />} />
              <Route path="/:id" element={<Meeting />} />
              <Route path="/l/:id" element={<Meeting live={true} />} />
              <Route path="/l/:id/:token" element={<Meeting live={true} />} />
              <Route path="/r/:id" element={<Recorded />} />
              <Route path="/metamask" element={<ElectronOneTime />} />
              <Route path="/face" element={<ElectronFace />} />
              <Route path="/record" element={<Meeting recording={true} />} />
              {/* <Route path="/upload" element={<StorageUpload />} /> */}
              <Route path="/faq" element={<HPFAQ />} />
              <Route path="/feedback" element={<Feedback />} />

              <Route path="/test" element={<Test />} />
              <Route path="/db" element={<DB />} />
              <Route path="/upload" element={<Upload />} />
            </Routes>
          </BrowserRouter>
        )}
      </>
    </RecoilRoot>
  </WagmiConfig>,
);
